var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.$t('form.button.edit')),expression:"$t('form.button.edit')"}],class:['edit', _vm.disabled ? 'text-secondary disabled' : 'text-info'],attrs:{"disabled":_vm.disabled},on:{"click":_vm.handleEdit}},[_c('i',{staticClass:"icon far fa-edit"})])
}
var staticRenderFns = []

export { render, staticRenderFns }